import { Icon } from '@blueprintjs/core'
import { lang, TokenRefresher, utils } from 'enablex/shared'
import cx from 'classnames'
import React, { FC, Fragment, useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Link } from 'react-router-dom'
import SplitPane from 'react-split-pane'

import api from '~/app/api'
import { fetchLoadedModules, loadModulesTranslations } from '~/management/modules/reducer'
import { fetchProfile } from '~/user/reducer'
import BottomPanel from './BottomPanel'

import CommandPalette from './CommandPalette'
import EventBus from './EventBus'
import Header from './Header'
import Menu from './Menu'
import { AppState } from './rootReducer'
import StatusBar from './StatusBar'
import style from './style.scss'
import { toggleBottomPanel } from './uiReducer'
const root = document.documentElement

const EXPANDED_PANEL_HEIGHT = 200

type Props = ConnectedProps<typeof connector>
const applyTheme = () => {
  let themeColor = '#1d6c90'
  const brandingString = localStorage.getItem('enx/branding')
  if (brandingString) {
      try {
          const branding = JSON.parse(brandingString)
          if (branding && branding.themeColor) {
              themeColor = branding.themeColor
          }
      } catch (error) {
        console.error('Error parsing branding data:', error)
      }
  }
  root.style.setProperty('--theme-color', themeColor)
}
const App: FC<Props> = props => {
  useEffect(() => {
    props.fetchProfile()
    props.fetchLoadedModules()
    props.loadModulesTranslations()
    EventBus.default.setup(window?.BOT_ID)
    applyTheme()
    if (window.localStorage.getItem('enx/channel-web/user-role') === 'agent') {
      if (typeof Notification !== 'undefined') {
        let permission = Notification.permission
        if (permission === 'default') {
          requestNotification()
        }
      }
    }
  }, [])

  if (!props.profile) {
    return null
  }

  function requestNotification() {
    void Notification.requestPermission(function (permission) {})
  }

  const splitPanelLastSizeKey = 'enx::bottom-panel-size'
  const lastSize = parseInt(localStorage.getItem(splitPanelLastSizeKey) || '175', 10)
  const bottomPanelHeight = props.bottomPanelExpanded ? EXPANDED_PANEL_HEIGHT : lastSize
  const bottomBarSize = props.bottomPanel ? bottomPanelHeight : '100%'

  return (
    <Fragment>
      <CommandPalette />
      <TokenRefresher getAxiosClient={() => api.getSecured()} />

      <div className={cx('bp-sa-wrapper', style.mainLayout)}>
        <Menu profile={props.profile} props={props} />
        <div className={style.container}>
          <Header />
          <SplitPane
            split="horizontal"
            defaultSize={lastSize}
            onChange={size => size > 100 && localStorage.setItem(splitPanelLastSizeKey, size.toString())}
            size={bottomBarSize}
            maxSize={-100}
            className={cx(style.mainSplitPaneWToolbar)}
          >
            <div className={cx('bp-sa-content-wrapper', style.main)} >
              {props.children}
            </div>
            <BottomPanel />
          </SplitPane>
        </div>
      </div>

      <StatusBar />
    </Fragment>
  )
}


const mapStateToProps = (state: AppState) => ({
  profile: state.user.profile,
  bottomPanel: state.ui.bottomPanel,
  bottomPanelExpanded: state.ui.bottomPanelExpanded
})

const connector = connect(mapStateToProps, {
  fetchProfile,
  toggleBottomPanel,
  fetchLoadedModules,
  loadModulesTranslations
})
export default connector(App)
